import { z } from 'zod';
import { CalendarEventType } from '@/features/calendar/types/calendar-dto';
import { t } from 'i18next';

export const CalendarPageFilterFormSchema = z.object({  
  startDate: z
    .date({ message: t('elements.form.startDate.error') })
    .nullable()
    .optional(),
  endDate: z
    .date()
    .nullable()
    .optional(),
  types: z
    .array(z.nativeEnum(CalendarEventType))
    .optional()  
}).refine(
  (data) =>
    data.startDate && data.endDate
      ? data.endDate >= data.startDate
      : true,
  {
    message: t('elements.form.datesDifference.error'),
    path: ['endDate'],
  },
);